import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './section.types';
import * as constants from './section.constants';

export const storeSesction = generateStoreResourceAction<types.ISection>(constants.STORE_SECTION);
export const clearSection = generateClearResourceAction(constants.CLEAR_SECTION);
